import React from 'react';
import PropTypes from 'prop-types';
import './aligner.scss';

const Aligner = ({children}) => <div className="aligner">{children}</div>;

Aligner.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Aligner;
